import type { FaireProductEntity } from "../../entity_types/product";

export const p_rvks6gmgzt: FaireProductEntity = {
  token: "p_rvks6gmgzt",
  type: "product",
  name: "Farfalle Pasta Baseball Cap/Dad Hat",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/069278c052a72f2a897f578cec5489ae7ff0b689d546734aca07fdabae5a7ac4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be4a51e4f2cec3a8694d899a091f8fb1259416f08b5ba12c01d73999fe7d514a.jpeg"
  ],
  priceDollars: 17.5,
  description: "Bring a taste of Italy to your style with the Farfalle Pasta Dad Hat. A soft, adjustable, and whimsical baseball cap makes the perfect accessory for food lovers and a great gift for pasta fanatics.\n\nGood to know:\n\n * Butter yellow hat with embroidered farfalle noodle design. \n * Features adjustable back buckle \n * Designed in Portland, Maine by Mel Andrel ",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:00.706Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
